// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__KKspA","col":"styles_col__2AV4R","fulfillmentStatus":"styles_fulfillmentStatus__17-TT","emailCol":"styles_emailCol__M75DW"};